import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnChanges } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Router } from '@angular/router';
import { MatTableFilter } from 'mat-table-filter';
import { RecruiterService } from 'src/app/modules/recruiterpersona/services/recruiter.service';

@Component({
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.scss'],
  standalone: false,
})
export class DynamicTableComponent implements OnInit, OnChanges {
  @ViewChild('matPagi', { static: true }) paginator: MatPaginator;
  @Input() isCheckbox;
  @Input() tableData;
  @Input() columns;
  @Input() checkLabel;
  @Input() showFilter;
  @Output() btnDisable = new EventEmitter();
  @Output() navigateTo = new EventEmitter();
  @Output() selectedValues = new EventEmitter();
  @Output() filteredData = new EventEmitter();

  dataSource: any;
  columnDefs: string[] = [];
  selection;
  noClickCols: any = [];
  pageNumber: any;
  selectedArray = [];
  filterEntity: any = {};
  filterType: MatTableFilter;
  compHiringId = localStorage.getItem('fresherCompHiringTypeId');
  get value() {
    // console.log(this.selection.selected);

    return this.selection.selected;
  }

  constructor(
    private router: Router,
    private _recruitrService: RecruiterService,
  ) {}

  ngOnInit() {
    this.setTableData();
  }
  goToPage() {
    this.paginator.pageIndex = this.pageNumber - 1; // number of the page you want to jump.
    this.paginator.page.next({
      pageIndex: this.pageNumber,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length,
    });
  }

  ngOnChanges() {
    this.setTableData();
  }

  setTableData() {
    this.columnDefs = [];
    this.selection = new SelectionModel<any>(true, []);
    if (this.isCheckbox) {
      this.columnDefs.push('checkbox');
    }
    this.dataSource = new MatTableDataSource(this.tableData);
    this.columns.forEach((element) => {
      this.columnDefs.push(element);
      this.filterEntity[element] = null;
    });
    this.dataSource.paginator = this.paginator;
    this.noClickCols = ['Role', 'Location', 'Due by', 'Target', 'Skills', 'Close Date', 'Created By', 'Unit'];
    this.filterType = MatTableFilter.ANYWHERE;
    this.filteredData.emit(this.dataSource.filteredData);
  }

  getPageData() {
    return this.dataSource._pageData(this.dataSource.filteredData);
  }

  isEntirePageSelected() {
    return this.getPageData().every((row) => this.selection.isSelected(row));
  }

  masterToggle(_checkboxChange: MatCheckboxChange) {
    if (this.isEntirePageSelected()) {
      this.selection.deselect(...this.getPageData());
    } else {
      this.selection.select(...this.getPageData());
    }
    this.selectedValues.emit(this.selection);
    this.btnDisable.emit(this.selection.selected.length === 0);
  }

  checkboxLabel(row?): string {
    if (!row) {
      return `${this.isEntirePageSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row[this.checkLabel]}`;
  }

  singleSelect(event, row) {
    if (event) {
      this.selection.toggle(row);
    }
    console.log(this.selection.selected);
    this.selectedValues.emit(this.selection);
    this.btnDisable.emit(this.selection.selected.length === 0);
  }

  checkColumn(column) {
    const ind = this.noClickCols.findIndex((ele) => {
      return ele == column;
    });
    if (ind == -1) {
      return true;
    } else {
      return false;
    }
  }
  columnSelect(column, value, element) {
    this.navigateTo.emit([column, value, element]);
    // this.router.navigate(["IL/requisition/4750/posting"]);
    // console.log(column,value);
  }

  filterCheck(column) {
    if (this.showFilter) {
      const filterCols = ['Created By', 'Location', 'PU', 'Req Id', 'Requisition Title', 'Role', 'Skills', 'Unit'];
      if (this.compHiringId == '4') {
        filterCols.push('Status');
      }
      if (filterCols.indexOf(column) != -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  filt() {
    //console.log("fDS",this.dataSource.filteredData);
    this.filteredData.emit(this.dataSource.filteredData);
  }

  restrictSpclChar(e, columnName) {
    if (columnName !== 'Skills') {
      return this._recruitrService.restrictSpclChar(e);
    }
  }

  rstrctSpclCharPaste(e, columnName) {
    if (columnName !== 'Skills') {
      return this._recruitrService.rstrctPasteSpclChar(e);
    }
  }
}
